import request from '@/router/axios'

export function fetchList(param) {
  return request({
    url: '/module/mcdonalds/admin/statistics/member-activities',
    method: 'get',
    params: param
  })
}

export function fetchMarketOptions() {
  return request({
    url: '/admin/admin/market-city/list',
    method: 'get'
  })
}

export function fetchRegionOptions() {
  return request({
    url: '/admin/admin/market-city/regionnames ',
    method: 'get'
  })
}

export function fetchPositionOptions() {
  return request({
    url: '/module/mcdonalds/position/list',
    method: 'get'
  })
}

// 获取餐厅列表
export function fetchStoreOptions(params) {
  return request({
    url: '/admin/admin/store/list',
    method: 'get',
    params
  })
}

// 获取 GM, DO, OC, OM 的相关信息
export function fetchStoreManagersOptions(params) {
  return request({
    url: '/admin/admin/store/managers',
    method: 'get',
    params,
  })
}

export function fetchDreamTreeList(param) {
  return request({
    url: '/module/mcdonalds/admin/statistics/tree-planting',
    method: 'get',
    params: param
  })
}

export function fetchRestaurantMatchesList(params) {
  return request({
    url: '/module/mcdonalds/admin/statistics/position-matches',
    method: 'get',
    params
  })
}

// 获取赛事统计_餐厅比拼列表
export function fetchStoreStatisticsOptions(params) {
  return request({
    url: '/module/mcdonalds/admin/statistics/position-matches-stats',
    method: 'get',
    params
  })
}

export function fetchActivityFilterOptions() {
  return request({
    url: '/admin/admin/store/managers',
    method: 'get',
  })
}

export function exportEmployeeActivityData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/member-activities/export',
    method: 'post',
    data
  })
}

export function exportMemberSignUpData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/member-signup/export',
    method: 'post',
    data
  })
}

export function fetchActivityFilter() {
  return request({
    url: '/admin/admin/member/role-info',
    method: 'get'
  })
}

export function exportPositionMatchRecordData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/position-matches/export',
    method: 'post',
    data
  })
}

export function exportPositionMatchStatisticsData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/position-matches-stats/export',
    method: 'post',
    data
  })
}

// 员工赛事统计_荣耀王者PK赛
export function fetchStaffOnlinePkStatisticsData(params) {
  return request({
    url: '/module/mcdonalds/admin/statistics/online-pk-result',
    method: 'get',
    params
  })
}

// 赛事统计_荣耀王者PK赛
export function fetchOnlinePkStatisticsData(params) {
  return request({
    url: '/module/mcdonalds/admin/statistics/online-pk-result-stats',
    method: 'get',
    params
  })
}

// 导出赛事统计_荣耀王者PK赛
export function exportOnlinePkStatisticsData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/online-pk-result-stats/export',
    method: 'post',
    data
  })
}

// 员工赛事统计_荣耀王者PK赛
export function exportStaffOnlinePkStatisticsData(data) {
  return request({
    url: '/module/mcdonalds/admin/statistics/online-pk-result/export',
    method: 'post',
    data
  })
}